import { createContext, useContext, useState } from 'react';

const ExperimentContext = createContext();
export const useExperiment = () => useContext(ExperimentContext);

export const ExperimentProvider = ({ children }) => {
  // ✅ Set to 'B' for full testing. Change to 'A1' or 'A2' later to hide points.
  const [CURRENT_PHASE, setPhase] = useState('B');
  const isPointsEnabled = CURRENT_PHASE === 'B';

  return (
    <ExperimentContext.Provider value={{ CURRENT_PHASE, setPhase, isPointsEnabled }}>
      {children}
    </ExperimentContext.Provider>
  );
};
